import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default (state = initialState.preferences, action) => {
  switch (action.type) {
    case types.CHANGE_LAST_LOCATION:
      return {
        ...state,
        lastLocation: {
          ...state.lastLocation,
          mainMenu: action.payload.mainMenu,
          mainModule: action.payload.mainModule,
          subModule: action.payload.subModule,
        },
      };
    case types.GET_PREFERENCES: {
      return {
        ...state,
        userPreferences: action.payload,
      };
    }
    case types.SET_PREFERENCE_STUDY_FLAG: {
      const preferenceFlags = { ...state.preferenceFlags };
      preferenceFlags[action.payload.pageName] = action.payload.flag;
      return {
        ...state,
        preferenceFlags,
      };
    }
    case types.SET_PREFERENCES: {
      return {
        ...state,
        autoUpdateFlag: true,
        userPreferences: action.payload,
      };
    }
    case types.AUTO_UPDATE_FLAG: {
      return {
        ...state,
        autoUpdateFlag: false,
      };
    }
    default:
      return state;
  }
}
